import { useMemo } from 'react';
import { t } from '../../localization';

const useCompactPlansData = ({
  computedPlans,
  planFeatures,
  activeCompactPlans,
  onCollapseClick,
}) =>
  useMemo(
    () =>
      computedPlans.map((plan) => {
        const { type } = plan;
        const collapsed = !activeCompactPlans.includes(type);

        return {
          ...plan,
          captions: {
            ...plan.captions,
            cta: t('Start with {planName}', {
              planName: plan.captions.name || type,
            }),
          },
          availabilities: planFeatures.reduce((availabilities, feature) => {
            if (feature.disabled) {
              return availabilities;
            }

            const targetAvailability = feature.availabilities.find(
              (availability) => availability.id === plan.type
            );

            if (targetAvailability && targetAvailability.compact !== null) {
              const { compact, contentType } = targetAvailability;
              availabilities.push({ text: compact, contentType });
            }

            return availabilities;
          }, []),
          collapsed,
          type,
          onCollapseClick,
        };
      }),
    [computedPlans, planFeatures, onCollapseClick, activeCompactPlans]
  );

export default useCompactPlansData;
